<template>
    <div class="dashboard-chart-loader mt-2">
      <v-skeleton-loader class="border" type="image"></v-skeleton-loader>
      <v-skeleton-loader class="border" type="image"></v-skeleton-loader>
      <v-skeleton-loader class="border" type="image"></v-skeleton-loader>
    </div>
  </template>
    
    <script>
  export default {
    name: "DashboardCharts",
  };
  </script>
    